import React from 'react';
import './App.css';
import Home from './components/pages/Home';
import Services from './components/pages/Services';
import AboutUs from './components/pages/AboutUs';
import Socia from './components/pages/Socia';
import Voluntaria from './components/pages/Voluntaria';
import Projects from './components/pages/Projects';
import Familia from './components/pages/Familia';
import Disfruta from './components/pages/Disfruta';
import Menu from './components/Menu';
import { AnimatePresence } from 'framer-motion';
import Boletin from './components/pages/Boletin';
import Footer from './components/Footer';
import UneteaHwasa from './components/pages/UneteaHwasa';
import ContactUs from './components/pages/ContactUs';
import styled from 'styled-components';
import GlobalStyle from './globalStyle';
import Orientación from './components/pages/Orientacion';
import 'bootstrap/dist/css/bootstrap.min.css';
import Laborales from './components/pages/Laborales';
import { Helmet } from "react-helmet";
import { Routes, Route, useLocation } from 'react-router-dom';

const Section = styled.section`
  overflow-x: hidden;
`;

function App() {
  const location = useLocation();

  return (
    <Section>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Hispanic Women's Association of South Australia</title>
        <link rel="canonical" href="https://hwasa.org.au/" />
        <meta name="description" content="Hispanic Women's Association of South Australia" />
      </Helmet>

      <Menu />
      <GlobalStyle />

      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<Home />} />
          <Route path="/quiénes somos" element={<AboutUs />} />
          <Route path="/áreas de enfoque" element={<Services />} />
          <Route path="/programas" element={<Projects />} />
          <Route path="/programas-la-familia" element={<Familia />} />
          <Route path="/programas-disfruta-en-línea" element={<Disfruta />} />
          <Route path="/programas-orientación-información" element={<Orientación />} />
          <Route path="/programas-oportunidades-laborales" element={<Laborales />} />
          <Route path="/boletin" element={<Boletin />} />
          <Route path="/unete-a-hwasa" element={<UneteaHwasa />} />
          <Route path="/unete-a-hwasa-socia" element={<Socia />} />
          <Route path="/unete-a-hwasa-voluntaria" element={<Voluntaria />} />
          <Route path="/contáctanos" element={<ContactUs />} />
        </Routes>
      </AnimatePresence>

      <Footer />
    </Section>
  );
}

export default App;
